'use client';

import { ReactNode } from 'react';

import { useTranslations } from 'next-intl';

import { SUPPORT_EMAIL } from 'data/adminPanel';
import Button from 'ui/Button';
import RoundedBox from 'ui/RoundedBox';

type SubriteErrorProps = {
  reset: () => void;
};
function SubriteError({ reset }: SubriteErrorProps) {
  const t = useTranslations('subriteError');
  return (
    <div className="flex flex-col items-center justify-center w-full">
      <div className="max-w-md">
        <RoundedBox>
          <h1 className="text-xl font-bold text-center md:text-2xl">{t('title')}</h1>
          <p className="mt-4 text-center md:text-xl">
            {t.rich('text', {
              link: (chunks: ReactNode) => (
                <a className="font-bold underline" href={`mailto:${SUPPORT_EMAIL}`}>
                  {chunks}
                </a>
              ),
            })}
          </p>
          <div className="flex items-center justify-center mt-10 gap-x-6">
            <Button onClick={() => reset()} color="black">
              {t('tryAgain')}
            </Button>
          </div>
        </RoundedBox>
      </div>
    </div>
  );
}

export default SubriteError;
